import profileUtils from '../../repositories/profileUtils';
import { NsPhoneNumberFormats } from '@nuskin/design-components';
import StringMask from 'string-mask';

export default {
    state: {
        account: {
            'id': '',
            'country': '',
            'email': '',
            'setupDate': '',
            'sponsorID': '',
            'preferredLanguage': '',
            'prefLanguageDisplayName': '',
            'beType': '',
            'accountType': '',
            'birthCountry': '',
            'preferences': {
                'acceptMarketingEmail': false,
                'acceptMarketingSMS': false,
                'showContactInfo': false,
                'showContactInfoToFamilyAndFriends': false,
                'showContactInfoToFirstUpLine': false,
                'visibleInScannerLocator': false,
                'visibleInSponsorSearch': false,
                'noFalloutMsg': false
            },
            'names': {
                'local': ''
            },
            'addresses': {
                'local': {
                    'line1': '',
                    'city': '',
                    'region': '',
                    'postalCode': '',
                    'country': ''
                }
            },
            'phoneNumbers': {
                'home': {
                    'country': '',
                    'value': ''
                },
                'mobile': {
                    'country': '',
                    'value': ''
                }
            }
        },
        marketLoggedIn: profileUtils.getCountry(),
        languageLoggedIn: profileUtils.getLanguage(),
        phoneCountries: profileUtils.getPhoneCountries(),
        trackingInfo: [],
        orderPrivacy: {
            txt: {
                sponsorLabel: 'Sponsor',
                groupLabel: 'Group Leaders',
                uplineRepLabel: 'Upline Brand Representatives'  
            },
            values: {
                sponsor: 1,
                group: 1,
                upline: 1
            }
        },
        japanStates: [],
        privacy: 3,
        languageList: []
    },
    getters: {
        orderPrivacy: (state) => {
            return state.orderPrivacy;
        },
        getTrackingInfo: (state) => (id) => {
            let result = state.trackingInfo.filter(e => e.id === id);
            if(result.length > 0) {
                return result[0].Tracking;
            } else {
                return [];
            }
        },
        sponsorId: (state) => {
            return state.account.sponsorID;
        },
        getJapanStates: (state) => (region) => {
            let result = state.japanStates.find(o => o.value === region);
            if(result) {
                return result.name;
            } else {
                return '';
            }
        },
        getPrivacy: (state) => {
            return state.privacy;
        },
        account: (state) => {
            return state.account;
        },
        marketLoggedIn: (state) => {
            return state.marketLoggedIn;
        },
        languageLoggedIn: (state) => {
            return state.languageLoggedIn;
        },
        showContactInfoToFirstUpLine: (state) => {
            return state.account.preferences.showContactInfoToFirstUpLine;
        },
        visibleInSponsorSearch: (state) => {
            return state.account.preferences.visibleInSponsorSearch;
        },
        preferredLanguage: (state) => {
            return state.account.preferredLanguage.toLowerCase();
        },
        prefLanguageDisplayName(state) {
            let retval = '';
            if (state.languageList) retval = state.languageList.find((item) => item.value === state.account.preferredLanguage?.toLowerCase())?.text || '';
            return retval;
        },
        country: (state) => {
            return state.account.country;
        },
        acceptMarketingEmail: (state) => {
            return state.account.preferences.acceptMarketingEmail;
        },
        acceptMarketingSMS: (state) => {
            return state.account.preferences.acceptMarketingSMS;
        },
        localAddress: (state) => {
            if (state.account.addresses !== null) {
                return state.account.addresses.local;
            }
            return {};
        },
        persons: (state) => {
            return state.account.persons;
        },
        gender: (state) => {
            return state.account.persons ? state.account.persons[0].gender : ''
        },
        nationality: (state) => {
            return state.account.birthCountry
        },
        email: (state) => {
            return state.account.email;
        },
        localName: (state) => {
            return state.account.names.local;
        },
        birthDate: (state) => {
            return state.account.persons[0].birthDate;
        },
        mobileNumber: (state) => {
            if (state.account.phoneNumbers.mobile) {
                return state.account.phoneNumbers.mobile.value;
            } else {
                return '';
            }
        },
        mobileFormatted: (state, getters) => {
            if(state.account.phoneNumbers.hasOwnProperty('mobile')){
                if (state.account.phoneNumbers.mobile.country !== '') {
                    let mask = NsPhoneNumberFormats[state.account.phoneNumbers.mobile.country].mask;
                    let value = StringMask.process(getters.mobileNumber, mask);
                    return value.valid ? value.result : getters.mobileNumber;
                } else {
                    return getters.mobileNumber;
                }
            }
            return 'default';
        },
        isHomeMarket: (state, getters) => {
            if (state.marketLoggedIn === 'PF' || state.marketLoggedIn === 'NC') {
                return true;
            } else {
                return getters.country === state.marketLoggedIn;
            }
        },
        isDistributor: (state) => {
            return state.account.beType === 'DIST';
        },
        isRetailCustomer: (state) => {
            return state.account.beType === 'CUST';
        },
        isMember: (state) => {
            return state.account.beType === 'PREF';
        },
        phoneCountries: (state) => {
            return state.phoneCountries;
        },
        accountType: state => {
            return state.account.beType;
        },
        accountTypeName: (state, getters) => {
            switch(state.account.beType){
                case 'DIST':
                    return getters.translationsPersonal.acct_conv_type_dist;
                case 'PREF':
                    return getters.translationsPersonal.acct_conv_type_pfc;
                case 'CUST':
                    return getters.translationsPersonal.acct_conv_type_customer;
            }
            return 'default';
        },
        bankAccounts: state => {
            return state.account.bankAccounts;
        },
        languageList: state => {
            console.log(state);
            return state.languageList;
        }
    },
    mutations: {
        setJapanStates: (state, payload) => {
            state.japanStates = [];
            payload.forEach((element, x) => {
                state.japanStates.push(element);
            });
        },
        setPrivacy: (state, payload) => {
            // force boolean
            state.privacy = parseInt(payload);
        },
        setOrderPrivacy: (state, payload) => {
            payload.forEach(item => {
                switch(item.key) {
                    case 'D-1':
                        state.orderPrivacy.values.sponsor = parseInt(item.value);
                        break;
                    case 'D-2':
                        state.orderPrivacy.values.group = parseInt(item.value);
                        break;
                    case 'D-3':
                        state.orderPrivacy.values.upline = parseInt(item.value);
                        break;
                }
            });
        },
        addTrackingInfo: (state, payload) => {
            state.trackingInfo.push(payload);
        },
        setAccount: (state, payload) => {
            state.account = payload;
        },
        setSponsor: (state, payload) => {
            state.account.sponsorID = payload;
        },
        setLanguageList: (state, payload) => {
            state.languageList = payload;
        },
        updateGender: (state, payload) => {
            state.account.persons[0].gender = payload;
        },
        updateEmail: (state, payload) => {
            state.account.email = payload;
        },
        updateBirthDate: (state, payload) => {
            state.account.persons[0].birthDate = payload;
        },
        updateMobileNumber: (state, payload) => {
            state.account.phoneNumbers.mobile.value = payload;
        },
        updatePreferredLanguage: (state, payload) => {
            state.account.preferredLanguage = payload;
        }
    },
    actions: {
        setJapanStates ({ commit }, text) {
            commit('setJapanStates', text);
        },
        setPrivacy ({ commit }, text) {
            commit('setPrivacy', text);
        },
        setOrderPrivacy ({ commit }, payload) {
            commit('setOrderPrivacy', payload);
        },
        addTrackingInfo ({ commit }, text) {
            commit('addTrackingInfo', text);
        },
        setAccount: ({ commit }, payload) => {
            commit('setAccount', payload);
        },
        setSponsor: ({ commit }, payload) => {
            commit('setSponsor', payload);
        },
        setLanguageList: ({commit}, payload) => {
            commit('setLanguageList', payload);
        },
        updateGender: ({ commit }, payload) => {
            commit('updateGender', payload);
        },
        updateEmail: ({ commit }, payload) => {
            commit('updateEmail', payload);
        },
        updateBirthDate: ({ commit }, payload) => {
            commit('updateBirthDate', payload);
        },
        updateLocalAddress: ({ commit }, payload) => {
            commit('setAccount', payload);
        },
        updateMobileNumber: ({ commit }, payload) => {
            commit('updateMobileNumber', payload);
        },
        updateIsHomeMarket: ({ commit }, payload) => {
            commit('updateIsHomeMarket', payload);
        },
        updatePreferredLanguage: ({commit}, payload) => {
            commit('updatePreferredLanguage', payload);
        }
    }
};
